import { get } from "radash"

import { v1CancelRideRequest } from "@be-miniapp/api"

export interface CancelFindingDriverAppViewParams {
  sessionId: number | undefined
  cancelledBy: string
  isMounted: () => boolean
  resetRideState: () => void
  navigate: (
    path: string,
    opts?: { replace?: boolean; animate?: boolean }
  ) => void
  toast: (opts: { description: string }) => void
}

/**
 * AppView: validate cancel API flags, reset live session on success, toast on hard errors.
 */
export async function cancelFindingDriverAppView(
  params: CancelFindingDriverAppViewParams
): Promise<void> {
  const data = await v1CancelRideRequest({
    session_id: `${params.sessionId ?? ""}`,
    cancelled_by: params.cancelledBy,
  })

  if (!params.isMounted()) return

  if (data?.flag === 112 || data?.flag === 143) {
    params.resetRideState()
    params.navigate("/ride/booking", { replace: true, animate: false })
    return
  }

  params.toast({
    description: get(data, "error", "Có lỗi xảy ra"),
  })
}

export interface CancelFindingDriverZaloParams {
  sessionId: number | undefined
  cancelledBy: string
  navigate: (
    path: string,
    opts?: { replace?: boolean; animate?: boolean }
  ) => void
}

/**
 * Zalo: fire-and-forget cancel then navigate home to booking (current product behavior).
 * Intentionally does not mirror AppView flag handling — keep platforms explicit.
 */
export async function cancelFindingDriverZalo(
  params: CancelFindingDriverZaloParams
): Promise<void> {
  await v1CancelRideRequest({
    session_id: `${params.sessionId ?? ""}`,
    cancelled_by: params.cancelledBy,
  })
  params.navigate("/ride/booking", { replace: true, animate: false })
}
